/** @license ISC License (c) copyright 2018 original and current authors */
/** @author Dale Francis (dalefrancis88) */

var isFunction = require('./isFunction')
var isNil = require('./isNil')

function isIterable(iterable) {
  return !isNil(iterable) && isFunction(iterable[Symbol.iterator])
}

module.exports = isIterable
